import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  constructor() { }

  handleConnectHttpStatus(status: number) : string {
    switch (status) {
      case 400:
      case 401:
        return 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut. ' +
          'Wenn das Problem bestehen bleibt, kontaktieren Sie bitte den LAND-DATA Benutzerservice.';
      case 403:
        return 'Sie haben nicht die nötigen Berechtigungen für diese Aktion.';
      case 409:
        return 'Eine Export Konfiguration mit dieser Verbindung besteht bereits.';
      default:
        return 'Die Verbindung konnte nicht hergestellt werden. Bitte versuchen Sie es später erneut.';
    }
  }

  handleReconnectHttpStatus(status: number) : string {
    switch (status) {
      case 400:
      case 401:
        return 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut. ' +
          'Wenn das Problem bestehen bleibt, kontaktieren Sie bitte den LAND-DATA Benutzerservice.';
      case 403:
        return 'Sie haben nicht die nötigen Berechtigungen für diese Aktion.';
      case 404:
        return 'Die Export Konfiguration wurde nicht gefunden.';
      default:
        return 'Die Verbindung konnte nicht hergestellt werden. Bitte versuchen Sie es später erneut.';
    }
  }

  handleFirmaHttpStatus(status: number) : string {
    switch (status) {
      case 400:
      case 401:
        return 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut. ' +
          'Wenn das Problem bestehen bleibt, kontaktieren Sie bitte den LAND-DATA Benutzerservice.';
      case 403:
        return 'Sie haben nicht die nötigen Berechtigungen für diese Aktion.';
      case 404:
        return 'Es wurde kein LAND-DATA Betrieb gefunden.';
      default:
        return 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
    }
  }

  /**
   * Meldungen für fehlgeschlagene Daten-Abrufe im Admin-Center.
   *
   * Bewusst technisch formuliert, da sich der Bereich an interne Nutzer richtet.
   * Der VPN-Hinweis steht ausschließlich bei Status 0: Nur dann kam keine
   * Antwort an. Bei 5xx antwortet der Service, die Verbindung besteht also -
   * ein VPN-Hinweis würde dort in die falsche Richtung führen.
   *
   * @param status HTTP-Status; 0 bedeutet, dass keine Antwort empfangen wurde
   */
  handleAdminDataLoadHttpStatus(status: number) : string {
    switch (status) {
      case 0:
        return 'Die Daten konnten nicht geladen werden. Der Export-Service ist nicht erreichbar - ' +
          'bitte prüfen Sie Ihre VPN-Verbindung.';
      case 401:
        return 'Die Daten konnten nicht geladen werden. Ihre Sitzung ist abgelaufen - ' +
          'bitte melden Sie sich erneut an.';
      case 403:
        return 'Die Daten konnten nicht geladen werden. Ihnen fehlt die Berechtigung für diese Ansicht.';
      case 404:
        return 'Die Daten konnten nicht geladen werden. Der angeforderte Eintrag wurde nicht gefunden.';
      case 429:
        return 'Die Daten konnten nicht geladen werden. Es wurden zu viele Anfragen gestellt - ' +
          'bitte versuchen Sie es in einem Moment erneut.';
      case 408:
      case 502:
      case 503:
      case 504:
        return 'Die Daten konnten nicht geladen werden. Der Export-Service ist derzeit nicht verfügbar. ' +
          'Bitte versuchen Sie es später erneut.';
      default:
        if (status >= 400 && status < 500) {
          return 'Die Daten konnten nicht geladen werden. Die Anfrage konnte nicht verarbeitet werden.';
        }
        if (status >= 500 && status < 600) {
          return 'Die Daten konnten nicht geladen werden. Im Export-Service ist ein Fehler aufgetreten.';
        }
        // INFO: Angular liefert auch bei 2xx einen HttpErrorResponse, wenn die
        // Antwort nicht geparst werden kann. Ohne diesen Zweig bliebe ein
        // solcher Fehler in den Listen unerklärt.
        return 'Die Daten konnten nicht geladen werden. Die Antwort des Export-Service war unerwartet.';
    }
  }

  /**
   * Meldung für einen fehlenden Verbindungsaufbau im Endkundenbereich.
   *
   * Bewusst ohne technische Begriffe: kein "Export-Service", kein VPN-Hinweis,
   * kein Statuscode. Der Text passt sowohl zu Abrufen als auch zu Aktionen, da
   * im Endkundenbereich ausschließlich Status 0 gemeldet wird - alle übrigen
   * Statuswerte behandeln die Wizard-Effects fachlich, teils als
   * Prozessweiche (z.B. 409 in checkIfConfigExists).
   *
   * @param status HTTP-Status; erwartet wird ausschließlich 0
   */
  handleCustomerConnectionHttpStatus(status: number) : string {
    switch (status) {
      case 0:
        return 'Es besteht derzeit keine Verbindung. Bitte prüfen Sie Ihre Internetverbindung ' +
          'und versuchen Sie es erneut.';
      default:
        return 'Die Aktion konnte nicht ausgeführt werden. Bitte versuchen Sie es später erneut.';
    }
  }
}
